import { useQuery } from "@tanstack/react-query";
import { getHeyApiRequestOptions } from "apiClients/base/heyApiRequestOptions";
import type { RevenueMarketFilter, RevenueTimeseriesResponse } from "../types";

async function fetchRevenueDailyTimeseries(
  year: number,
  month: number,
  currency: RevenueMarketFilter,
): Promise<RevenueTimeseriesResponse> {
  const options = getHeyApiRequestOptions();
  const auth = options.auth?.();
  const params = new URLSearchParams({
    year: String(year),
    month: String(month),
  });
  if (currency) {
    params.set("currency", currency);
  }

  const response = await fetch(
    `${options.baseUrl}/api/statistics/revenue/timeseries/daily?${params}`,
    {
      headers: {
        Accept: "application/json",
        ...(auth ? { Authorization: auth } : {}),
      },
    },
  );

  if (!response.ok) {
    throw new Error(`Failed to load daily revenue timeseries (${response.status})`);
  }

  return (await response.json()) as RevenueTimeseriesResponse;
}

export function useRevenueDailyTimeseriesQuery(
  year: number | null,
  month: number | null,
  currency: RevenueMarketFilter = null,
) {
  const enabled = year != null && month != null && month >= 1 && month <= 12;

  return useQuery({
    queryKey: [
      "dashboard-revenue-daily-timeseries",
      year,
      month,
      currency ?? "all",
    ],
    queryFn: () => fetchRevenueDailyTimeseries(year!, month!, currency),
    enabled,
  });
}
